"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPageContent = exports.StyledPageContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledPageContainer = styled_components_1.default.div `
  display: flex;
  position: relative;
`;
exports.StyledPageContent = styled_components_1.default.div `
  width: ${({ $sideBarWidth }) => `calc(100% - ${$sideBarWidth}px)`};
`;
